import { createSlice } from "@reduxjs/toolkit";

const formData = {
    position: true,
    name: true,
    age: true,
    extra: true,
}

const getClone = () => JSON.parse(JSON.stringify(formData))

const initialState = [];

export const columnsSlice = createSlice({
    name: "columns",
    initialState,
    reducers: {
        addColumn: (state, { payload }) => { state.push({ ...payload }) },
        toggleColumn: (state, action) => {
            const { index, key } = action.payload;
            state[index][key] = !state[index][key];
        },
        resetColumns: () => [],
    }
})



export const { addColumn, toggleColumn, resetColumns } = columnsSlice.actions

export default columnsSlice.reducer